import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedAuthGuestRole } from "@src/ducks/slices/auth.slice";
import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { View, useWindowDimensions } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import DrawerGuest from "screens/guest-screen/drawer-component";
import { DrawerContext } from "./drawer-provider";
import DrawerComponent from "./drawer-component";
import useStyles from "./styles.css";
import SupportButton from "./support-button";
import MainScreenAnimatedScroll from "./main-screen-animated-scroll";
import { SignatureProvider } from "../affix-document/provider/signature";
import { tabletSize, mobileSize } from "@src/utils/screensize-helper";

const MainScreen = () => {
  const styles = useStyles();
  const isLargeSize = !tabletSize() && !mobileSize()
  const { height } = useWindowDimensions();
  const isGuest = useAppSelector(selectedAuthGuestRole);
  const { activeTab } = React.useContext(DrawerContext);
  const isAffixDocument = activeTab === "Affix Document";

  return (
    <View style={styles.container}>
      <SafeAreaView />
      {(!isGuest || isAffixDocument) &&
        <LinearGradient
          colors={["#F9F9F9", "#F9F9F9"]}
          locations={[0.4, 1]}
          style={[styles.linear_style]}
        />
      }
      {isLargeSize &&
        <View style={[
          styles.drawerContainer, 
          isGuest && styles.guest_drawer,
          { maxHeight: height}
        ]}>
          {isGuest ? <DrawerGuest /> : <DrawerComponent />}
        </View>
      }
      {!isAffixDocument &&
         <MainScreenAnimatedScroll />
      }
      {isAffixDocument  &&
        <SignatureProvider>
          <MainScreenAnimatedScroll />
        </SignatureProvider>
      }
      <SupportButton />
    </View>
  );
};

export default React.memo(MainScreen);
